/*
 * @Author: your name
 * @Date: 2019-10-09 14:51:52
 * @LastEditTime: 2019-12-17 10:17:41
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \operation-mobile\src\store\modules\types.js
 */
// APP模块
export const APP_CURRENT_MODULE = 'APP_CURRENT_MODULE'; // 当前所处模块
export const APP_WX_AUTHENTICATE = 'APP_WX_AUTHENTICATE'; // 当前所处模块
export const APP_OP_ID = 'APP_OP_ID'; // 当前所处模块
export const APP_DEVICE_READY = 'APP_DEVICE_READY'; // 状态
export const APP_PAGE_LIST = 'APP_PAGE_LIST'; // 页面栈
export const APP_LOAD_WX_CONFIG = 'APP_LOAD_WX_CONFIG'; // 页面栈
export const APP_LOGIN_STATUS = 'APP_LOGIN_STATUS'; // app登录状态
export const APP_PAGE_DIRECTION = 'APP_PAGE_DIRECTION'; // app页面的方向
export const APP_CTAB_INDEX = 'APP_CTAB_INDEX'; // 当前选中的tab
export const APP_CUSERINFO = 'APP_CUSERINFO'; // 当前用户信息
export const APP_SEARCH_INFO = 'APP_SEARCH_INFO'; // 搜索信息
export const APP_ADDRESS_BEGIN_ID = 'APP_ADDRESS_BEGIN_ID'; // 当前用户信息
export const APP_MERCHANT_INFO = 'APP_MERCHANT_INFO'; // 当前商户配置信息
